/* eslint-disable react-refresh/only-export-components */
import type { ReactNode } from 'react';
import React, { createContext, useContext, useState } from 'react';

export interface Tab {
  key: string;
  title: string;
}

export interface NavigationStore {
  activeTab: string;
  setActiveTab: (_: string) => void;
  visibleTabs: Tab[];
  setVisibleTabs: (_: Tab[]) => void;
}

const NavigationContext = createContext({} as NavigationStore);

export function NavigationProvider({ children }: { children: ReactNode }) {
  const [activeTab, setActiveTab] = useState<string>('dashboard');
  const [visibleTabs, setVisibleTabs] = useState<Tab[]>([]);

  return React.createElement(
    NavigationContext.Provider,
    {
      value: {
        activeTab,
        setActiveTab,
        visibleTabs,
        setVisibleTabs,
      },
    },
    children,
  );
}

export function useNavigation() {
  return useContext(NavigationContext);
}
